import React, { useEffect } from 'react'

export default function Map() {
    useEffect(() => {
        window.location.replace('https://www.google.com/maps/dir/?api=1&destination=36.29337144002341,59.57897543907166&travelmode=driving')
    }, [])

    return (
        <div>redirect ...</div>
    )
}
